import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import BrandMark from './BrandMark';

/**
 * Shared marketing header + footer (same look as Landing).
 * Nav/footer use path URLs so subpages are crawlable and consistent with the sitemap.
 */
export default function LandingChrome({ children }) {
  const { lang, toggleLang, t } = useLang();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="landing">
      <div className="particles">
        {[...Array(20)].map((_, i) => (
          <span
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 8}s`,
              animationDuration: `${6 + Math.random() * 10}s`,
              width: `${2 + Math.random() * 4}px`,
              height: `${2 + Math.random() * 4}px`,
            }}
          />
        ))}
      </div>

      <header className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
        <div className="nav__inner">
          <div className="nav__logo" onClick={() => navigate('/')} role="presentation">
            <BrandMark
              imgClassName="nav__logo-icon nav__logo-icon--mark"
              fallbackClassName="nav__logo-icon"
            />
            <span>ReplyTek</span>
          </div>
          <nav className="nav__links">
            <a href="/features">{t('features')}</a>
            <a href="/pricing">{t('pricing')}</a>
            <a href="/faq">{t('faq')}</a>
          </nav>
          <button
            type="button"
            className="nav__hamburger"
            onClick={() => setMobileMenu(!mobileMenu)}
            aria-expanded={mobileMenu}
            aria-label="Menu"
          >
            <span />
            <span />
            <span />
          </button>
          <div className="nav__actions">
            <button type="button" className="btn-lang" onClick={toggleLang}>{lang === 'en' ? 'ES' : 'EN'}</button>
            <button type="button" className="btn-ghost" onClick={() => navigate('/login')}>{t('sign_in')}</button>
            <button type="button" className="btn-primary" onClick={() => navigate('/signup')}>{t('get_started')}</button>
          </div>
        </div>
        {mobileMenu && (
          <div className="nav__mobile-menu">
            <a href="/features" onClick={() => setMobileMenu(false)}>{t('features')}</a>
            <a href="/pricing" onClick={() => setMobileMenu(false)}>{t('pricing')}</a>
            <a href="/faq" onClick={() => setMobileMenu(false)}>{t('faq')}</a>
            <div className="nav__mobile-actions">
              <button type="button" onClick={() => { setMobileMenu(false); navigate('/login'); }}>{t('sign_in')}</button>
              <button type="button" onClick={() => { setMobileMenu(false); navigate('/signup'); }} className="nav__mobile-cta">{t('get_started')}</button>
            </div>
          </div>
        )}
      </header>

      {children}

      <footer className="footer">
        <div className="footer__inner">
          <div className="footer__brand">
            <BrandMark
              imgClassName="nav__logo-icon nav__logo-icon--mark"
              fallbackClassName="nav__logo-icon"
            />
            <span>ReplyTek</span>
          </div>
          <div className="footer__links">
            <a href="/features">{t('features')}</a>
            <a href="/pricing">{t('pricing')}</a>
            <a href="/faq">{t('faq')}</a>
          </div>
          <p className="footer__disclaimer">
            {lang === 'en'
              ? 'ReplyTek is not affiliated with WhatsApp or Meta. WhatsApp is a trademark of Meta Platforms, Inc.'
              : 'ReplyTek no está afiliado con WhatsApp o Meta. WhatsApp es una marca registrada de Meta Platforms, Inc.'}
          </p>
          <p className="footer__copy">© 2026 ReplyTek. {lang === 'en' ? 'All rights reserved.' : 'Todos los derechos reservados.'}</p>
        </div>
      </footer>
    </div>
  );
}
